import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { LOGIN, LOGIN_FAILED, LOGIN_SUCCESS, REFERSH_TOKEN_FAILED, REFRESH_TOKEN, REFRESH_TOKEN_SUCCESS } from "./actionTypes"


export const handleLogin = (email, password) => async dispatch => {
    dispatch({
        type: LOGIN
    })
    try{
        let response = await api(`auth/login`, 'post', { email, password })
        console.log('login data', response)
        localStorage.setItem("user", JSON.stringify(response.data))
        dispatch({
            type: LOGIN_SUCCESS,
            payload: response?.data
        })
        return response?.data
    }catch(e){
        console.log(e)
        toast.error("Login failed!")
        return Promise.reject(
            dispatch({
                type: LOGIN_FAILED,
                payload: e?.message
            })
        )
    }
}

export const refreshToken = (refresh_token) => async dispatch => {
    dispatch({
        type: REFRESH_TOKEN
    })
    try{
        let response = await api('auth/refreshtoken', 'post', { refresh_token })
        if(!response.status === 200){ 
            dispatch({
            type: REFERSH_TOKEN_FAILED,
            payload: response.data
        })
            return response 
        }
        dispatch({
            type: REFRESH_TOKEN_SUCCESS,
            payload: response?.data
        })
        return response
    }catch(e){
        return dispatch({
            type: REFERSH_TOKEN_FAILED,
            payload: e?.message
        })
    }
}